import ErrorBox from '@components/common/ErrorBox';
import NotifyForm from '@stone/components/notify/NotifyForm';
import ModalDialog from '@stone/components/modal/ModalDialog';
import analytics from '@stone/utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductTileReview from '@stone/components/product/ProductTileReview';
const ProductNotifyMeModal = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [requestSent, setRequestSent] = useState();
    const [fullproductid, setFullproductid] = useState();
    const [errors, setErrors] = useState([]);
    const { product, color, size } = props;
    useEffect(() => {
        var _a, _b, _c;
        if (color) {
            setFullproductid(`${(_a = props.product) === null || _a === void 0 ? void 0 : _a.masterId}${(_b = props.color) === null || _b === void 0 ? void 0 : _b.id}${(_c = props.size) === null || _c === void 0 ? void 0 : _c.id}`);
        }
    }, [product, color, size]);
    // non renderizzare la modale all'apertura della pagina, non fare chiamate se non aperta
    const firstRender = useRef(true);
    useEffect(() => {
        if (props.isOpen && firstRender.current) {
            firstRender.current = false;
            let val = {};
            api.getForm('notifyme-product', val).then((data) => {
                prefillValues(val);
                setFormdef(data);
                if (window.loggedin) {
                    api.getUserPrefillInfo().then((user) => {
                        setInitialValues(Object.assign(Object.assign({}, val), user));
                    });
                }
                else {
                    setInitialValues(val);
                }
            });
        }
    }, [props.isOpen]);
    const prefillValues = (values) => {
        values.productid = fullproductid;
        values.from = window.location.href; // debug invalid forms
    };
    const validate = async (values) => {
        prefillValues(values);
        return await formutils.validateForm(values, formdef, 'notifyme-product');
    };
    const onSubmit = async (values) => {
        prefillValues(values);
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        api.notifymeSubmit(values, formdef).then((data) => {
            var _a, _b;
            let errors = {};
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            analytics.notifyMe(`${(_a = props.product) === null || _a === void 0 ? void 0 : _a.masterId}${(_b = props.color) === null || _b === void 0 ? void 0 : _b.id}`, 'submit');
            setRequestSent(values);
        });
    };
    const review = useCallback(() => {
        return (React.createElement("div", { className: "product-notify__detail__confirm", role: "alert" },
            React.createElement("p", null,
                React.createElement("span", { className: "font-medium" },
                    React.createElement("b", null, t('notifyme.thankyou'))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("span", null, t('notifyme.confirmation')))));
    }, [requestSent]);
    const notifyForm = () => (React.createElement(NotifyForm, { color: props.color, size: props.size, formdef: formdef, onSubmit: onSubmit, initialValues: initialValues, validate: validate, buttonText: t('label.notifyme') }));
    const content = () => {
        if (requestSent) {
            return review();
        }
        else {
            return notifyForm();
        }
    };
    return (React.createElement(ModalDialog, { fullHeight: true, fullWidth: true, hasDivisor: true, isOpen: props.isOpen, onAfterOpen: () => {
            var _a, _b;
            analytics.notifyMe(`${(_a = props.product) === null || _a === void 0 ? void 0 : _a.masterId}${(_b = props.color) === null || _b === void 0 ? void 0 : _b.id}`);
        }, onRequestClose: props.onRequestClose, onAfterClose: () => setRequestSent(null), contentLabel: props.title, id: "notifyme", className: "lg-scrollable", subjsx: () => React.createElement(ProductTileReview, { product: props.product, color: props.color, size: props.size }), style: { content: { height: props.fromReserve ? document.querySelector('#reserveinboutique').offsetHeight : undefined } } },
        React.createElement("div", { className: "product-notify" },
            React.createElement("div", { className: "product-notify__detail" }, content()),
            React.createElement(ErrorBox, { errors: errors }))));
};
export default ProductNotifyMeModal;
